import { useTranslation } from 'react-i18next'

import { Avatar } from '../../Avatar'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { Divider } from '../../Divider'
import { EntityArchivedIcon } from '../../Entity'
import { STATUS_SIZE_20 } from '../../Status'
import Text from '../../Text'
import { UserStatusTag } from '../../User'

import { QA_NAME_PROFILE_USER_INFO_OPEN_PROFILE_BUTTON } from './ProfileUserInfoItemCard.constants'
import { getProfileUserCardContactKey } from './ProfileUserInfoItemCard.utils'
import { ProfileUserInfoItemCardContactRow } from './ProfileUserInfoItemCardContactRow'

import * as styles from './ProfileUserInfoItemCard.module.css'

import Archive2Icon from '../../../icons/archive-2.svg'

function ProfileUserInfoItemCard({
  cardData,
  className = styles.card,
  onMouseEnter,
  onMouseLeave,
  onOpenProfile,
}) {
  const { t } = useTranslation()

  return (
    <div
      className={className}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {cardData ? (
        <>
          <div className={styles.header}>
            <div className={styles.headerMain}>
              <Avatar
                color={cardData.avatarColor}
                src={cardData.avatar}
                text={cardData.fullname}
              />
              <div className={styles.headerInfo}>
                <Text className={styles.name}>{cardData.fullname}</Text>
                {cardData.role ? (
                  <Text isSecondary>{cardData.role}</Text>
                ) : null}
                {Number.isFinite(cardData.status) ? (
                  <UserStatusTag
                    className={styles.statusTag}
                    height={STATUS_SIZE_20}
                    value={cardData.status}
                  />
                ) : null}
              </div>
            </div>
            {cardData.isArchived ? (
              <EntityArchivedIcon Icon={Archive2Icon} />
            ) : null}
          </div>
          <Divider className={styles.divider} />
          {cardData.contacts?.length > 0 ? (
            <div className={styles.contacts}>
              {cardData.contacts.map((contact, index) => (
                <ProfileUserInfoItemCardContactRow
                  contact={contact}
                  key={getProfileUserCardContactKey(contact, index)}
                />
              ))}
            </div>
          ) : null}
          <div className={styles.footer}>
            <Button.Outlined
              isGrey
              className={styles.openProfileButton}
              height={BUTTON_HEIGHT_32}
              qaName={QA_NAME_PROFILE_USER_INFO_OPEN_PROFILE_BUTTON}
              text={t('Notification.CommonOpenProfileLinkKey')}
              onClick={onOpenProfile}
            />
          </div>
        </>
      ) : null}
    </div>
  )
}

export default ProfileUserInfoItemCard
